import { Facet } from "@linkfluence/models/facet";
import {
  demographicId,
  globalVolumeAndKPIId,
} from "@radarly/models/cards/term";
import { Categories } from "@radarly/models/facets";

type Value = {
  value: string;
  label?: string;
  compatible?: boolean;
};

export type Section = {
  title?: string;
  values: Value[];
};

export const categories = [
  {
    title: "FACETS::FILTERS::ATTRIBUTES",
    values: [
      globalVolumeAndKPIId,
      Facet.Focuses,
      Facet.Platforms,
      Facet.Tones,
      Facet.Languages,
      Facet.Countries,
      Facet.Hashtags,
    ],
  },
  {
    title: Categories["text"],
    values: [
      Facet.Entities,
      Facet.Keyphrases,
      Facet.Mentions,
      Facet.ContentClassification,
      Facet.Topics,
      Facet.Affects,
      Facet.Emotions,
      Facet.EmojiCharts,
    ],
  },
  {
    title: Categories["image"],
    values: [
      Facet.ImageRecognitionPersons,
      Facet.ImageRecognitionEmotions,
      Facet.ImageRecognitionGenders,
      Facet.ImageRecognitionAge,
      Facet.ImageRecognitionObjects,
      Facet.ImageRecognitionScenes,
      Facet.ImageRecognitionLogos,
      Facet.ImageRecognitionPersonIdentifications,
    ],
  },
  {
    title: Categories["posts"],
    values: [Facet.Countries, Facet.Regions, Facet.Towns],
  },
  {
    title: Categories["author"],
    values: [Facet.Genders, demographicId, Facet.Occupations],
  },
  {
    title: Categories["reviews"],
    values: [
      Facet.ReviewRate,
      Facet.Franchise,
      Facet.ProductRange,
      Facet.Product,
    ],
  },
  {
    title: Categories["misc"],
    values: [Facet.Devices],
  },
];
